<template>
  <button
    :id="id"
    class="inline-flex items-center rounded-full transition-colors focus:outline-none focus-visible:ring focus-visible:ring-offset-2 disabled:cursor-not-allowed"
    :class="[
      checkedValue ? colors[color].wrapper.on : 'bg-neutral-200',
      sizes[size].wrapper,
      colors[color].wrapper.base,
    ]"
    :disabled="isDisabled"
    @click="handleChange"
    :test_id="$attrs.test_id"
  >
    <span
      class="rounded-full shadow transition-transform"
      :class="[
        checkedValue ? sizes[size].translate.on : sizes[size].translate.off,
        isDisabled ? 'bg-neutral-50' : 'bg-white',
        sizes[size].dot,
      ]"
    />
  </button>
</template>

<script setup>
import { computed, useId } from 'vue'

const props = defineProps({
  modelValue: {
    type: [Array, Boolean],
    default: false,
  },
  value: {
    type: String,
    default: '',
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'regular',
  },
  color: {
    type: String,
    default: 'success',
  },
})

const emit = defineEmits(['update:checked', 'update:modelValue'])

const id = `growthmentor-toggle-${useId()}`

const checkedValue = computed(() => {
  return Array.isArray(props.modelValue)
    ? props.modelValue.includes(props.value)
    : props.modelValue
})

const handleChange = () => {
  if (Array.isArray(props.modelValue)) {
    const toggleArray = [...props.modelValue]
    if (toggleArray.includes(props.value)) {
      toggleArray.splice(toggleArray.indexOf(props.value), 1)
    } else {
      toggleArray.push(props.value)
      emit('update:checked', props.value)
    }
    emit('update:modelValue', toggleArray)
  } else {
    const newValue = !props.modelValue
    if (newValue) emit('update:checked', props.value)
    emit('update:modelValue', newValue)
  }
}

const sizes = {
  small: {
    wrapper: 'h-6 w-12',
    dot: 'h-4 w-4',
    translate: {
      on: 'translate-x-7',
      off: 'translate-x-1',
    },
  },
  regular: {
    wrapper: 'h-8 w-16',
    dot: 'h-6 w-6',
    translate: {
      on: 'translate-x-9',
      off: 'translate-x-1',
    },
  },
}

const colors = {
  success: {
    wrapper: {
      base: 'focus-visible:ring-success-500',
      on: 'bg-success-500 disabled:bg-success-300',
    },
  },
  secondary: {
    wrapper: {
      base: 'focus-visible:ring-secondary-500',
      on: 'bg-secondary-500 disabled:bg-secondary-300',
    },
  },
}
</script>
